<template>
  <small
    >Made with <v-icon color="red" x-small>mdi-heart</v-icon> by
    <a class="link" href="https://xstudios.com/" target="_blank"
      >X Studios&trade;</a
    >
    in Winter Park, FL.</small
  >
</template>

<style>
  .link {
    text-decoration: none;
    color: inherit;
  }
  .link:hover {
    color: inherit;
  }
</style>
